import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEOHead = ({ 
  title = "Shot Clock Dating - World's First AI-Powered Speed Dating Platform",
  description = "Connect with compatible singles through timed video conversations. Experience the sophisticated art of connection through curated speed dating sessions powered by AI. Start your journey to love today!",
  keywords = "speed dating, AI dating, video dating, online dating, matchmaking, timed conversations, AI powered dating, dating app, find love, compatible singles, intelligent matchmaking, virtual speed dating, dating platform, love connection, relationship app",
  image = "https://shotclockdating.com/og-image.jpg",
  url = "https://shotclockdating.com/",
  type = "website"
}) => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": title,
    "description": description,
    "url": url,
    "image": image,
    "publisher": {
      "@type": "Organization",
      "name": "Shot Clock Dating",
      "logo": {
        "@type": "ImageObject",
        "url": "https://shotclockdating.com/original_logo.png"
      }
    },
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://shotclockdating.com/search?q={search_term_string}",
      "query-input": "required name=search_term_string"
    }
  };

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Shot Clock Dating" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export default SEOHead;